import { filterClasses } from "@swivl-mono/helpers";
import { ChangeEvent, LegacyRef } from "react";
import { LuSearch } from "react-icons/lu";

export interface SelectDropdownSearchProps {
  disabled?: boolean;
  inputRef: LegacyRef<HTMLInputElement>;
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
}

export const SelectDropdownSearch = ({ disabled = false, inputRef, searchQuery, onSearchQueryChange }: SelectDropdownSearchProps): JSX.Element => {
  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    onSearchQueryChange(event.target.value);
  };

  return (
    <div className="mb-2 flex items-center gap-2 rounded-sm border border-grey-400 px-3 hover:border-orange-500">
      <input
        type="text"
        ref={inputRef}
        value={searchQuery}
        onChange={handleSearchChange}
        placeholder="Search"
        className={filterClasses(
          "w-full rounded-sm py-1.5 text-sm outline-none",
          "text-grey-900",
          "placeholder:text-grey-500",
          "caret-orange-500 group-data-[error=true]:caret-red-500",
          "disabled:cursor-not-allowed disabled:bg-grey-200 disabled:text-grey-500"
        )}
        disabled={disabled}
      />
      <LuSearch className="size-4 text-grey-600" />
    </div>
  );
};
